/**
 * Enum for Canvas context textAlign property
 * @readonly
 * @enum {string}
 */
const textAlign = Object.freeze({
	CENTER: 'center',
	// END: 'end',
	LEFT: 'left',
	RIGHT: 'right'
	// START: 'start'
});

/**
 * Enum for Canvas context textBaseline property
 * @readonly
 * @enum {string}
 */
const textBaseline = Object.freeze({
	ALPHABETIC: 'alphabetic',
	// BOTTOM: 'bottom',
	HANGING: 'hanging',
	// IDEOGRAPHIC: 'ideographic',
	MIDDLE: 'middle'
	// TOP: 'top'
});

export {
	textAlign,
	textBaseline
};

/**
 * Enums associated with Canvas context methods
 * @readonly
 * @enum {object}
 */
export default {
	textAlign,
	textBaseline
};
